import { render, staticRenderFns } from "./LinkHelper.vue?vue&type=template&id=f4ef66a6"
import script from "./LinkHelper.vue?vue&type=script&lang=js"
export * from "./LinkHelper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports